/** Detects if rendering in a Next.js environment */
export const useIsNextJs = () => {
  try {
    // Requiring useRouter this way prevents a bundle-level issue in the router from crashing the app
    // eslint-disable-next-line @typescript-eslint/no-var-requires,global-require
    const {useRouter} = require('next/router');
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useRouter();
    return true;
  } catch (e) {
    return false;
  }
};
